<template>
  <v-container fluid grid-list-md>
    <v-card style="padding: 16px" class="mx-auto">
      <v-card-text class="headline font-weight-bold">
        <v-card-actions class="headline font-weight-bold">
          <div>
            <h3>Pagamentos</h3>
          </div>

          <v-spacer></v-spacer>
        </v-card-actions>
        <div style="font-size: 16px; font-weight: 400">
          <i>Utilize os Filtros para melhorar a sua busca.</i>
        </div>
        <v-layout align-center justify-end>
          <v-btn fab top right small @click="enableFilters">
            <v-icon>filter_list</v-icon>
          </v-btn>
          <export />
        </v-layout>
      </v-card-text>
    </v-card>
    <partner-payments />
    <filters />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { changed } from "@/helpers/layout";

export default {
  name: "Partner-Payments",
  created() {
    // Arriving from an establishment's "Pagamentos e Recebíveis" pre-filters
    // this screen by that establishment. Set it here, before mounted() and the
    // async child components load, so every load already carries the filter.
    const establishmentId = this.$route.query.establishment;
    this.$store.commit(
      "partners_payments/SET_FILTER_ACCOUNT_ID",
      establishmentId || null
    );
  },
  mounted() {
    this.$store.dispatch("partners_payments/load", this.filters);
  },
  computed: {
    ...mapGetters({
      payments: "partners_payments/partnerPayments",
      totalResources: "partners_payments/totalResources",
      limitOptions: "partners_payments/limitOptions",
      currentPage: "partners_payments/currentPage",
      filters: "partners_payments/filterParams",
      filtersExport: "partners_payments/filterExportReport",
      subtotal: "partners_payments/subtotal",
    }),
    pages() {
      return 0;
    },
  },
  methods: {
    ...mapActions({
      setCurrentPage: "payments/setCurrentPage",
      setLimit: "payments/setLimit",
    }),
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    setClass(status) {
      return `payment ${status}`;
    },
  },
  watch: {
    pagination: function pagination(newPagination, oldPagination) {
      if (changed(newPagination.rowsPerPage, oldPagination.rowsPerPage)) {
        this.setLimit(newPagination.rowsPerPage);
        this.$store.dispatch("partners_payments/load", this.filters);
      }
      if (changed(newPagination.page, oldPagination.page)) {
        this.setCurrentPage(newPagination.page);
        this.$store.dispatch("partners_payments/load", this.filters);
      }
    },
  },
  components: {
    PartnerPayments: () => import("@/components/partners-payments/PartnerPayments.vue"),
    Filters: () => import("@/components/partners-payments/Filters.vue"),
    Export: () => import("@/components/partners-payments/Export.vue"),
  },

  methods: {
    enableFilters() {
      this.$store.dispatch("partners_payments/showFilters", true);
    },
    goTo(route) {
      this.$router.push({ name: route });
      this.hideNavigation();
    },
  },
};
</script>
